import en from './en';
import ro from './ro';
import es from './es';

export default {
  en,
  ro,
  es,
};
